import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

const SPKPanelDisplayedSkills = ({
  skill,
  index,
  containerRef,
  setOverflowIndex,
  totalSkills,
}: {
  skill: string;
  index: number;
  containerRef: HTMLDivElement | null;
  setOverflowIndex: (index: number) => void;
  totalSkills: number;
}) => {
  const { ref, entry } = useInView({
    root: containerRef as HTMLDivElement,
    triggerOnce: true,
  });

  useEffect(() => {
    if (entry?.intersectionRatio === undefined) return;

    if (entry.intersectionRatio < 1) {
      setOverflowIndex(index);
    } else if (totalSkills === index + 1) {
      setOverflowIndex(0);
    }
  }, [entry?.intersectionRatio, index, setOverflowIndex, totalSkills]);

  return (
    <span
      ref={ref}
      className="text-xs rounded border border-gray-300 p-1 text-nowrap text-black/60"
    >
      {skill}
    </span>
  );
};

export default SPKPanelDisplayedSkills;
